import axios from '@/router/axios'

class BaseApi {
  path = ''

  constructor(path) {
    this.path = path
  }

  getAll = params => this.get(`${this.path}/all`, params)

  getCount = params => this.get(`${this.path}/count`, params)

  getList = params => this.get(`${this.path}/page`, params)

  add = obj => this.post(this.path, obj)

  getById = id => this.get(`${this.path}/${id}`)

  del = id => axios.delete(`${this.path}/${id}`)

  update = obj => this.put(this.path, obj)

  get = (path, params) => axios.get(path, { params })

  post = (path, obj) => axios.post(path, obj)

  put = (path, obj) => axios.put(path, obj)

  getAxios = () => axios

  setPath = path => {
    this.path = path
  }
}

export default BaseApi
